import React, { Component } from "react";

import { Collapse, Layout } from "antd";

import { FormattedMessage, FormattedHTMLMessage, defineMessages,   injectIntl } from "react-intl";
import GuideNav from "../components/navigation/GuideNav";
import Headline from "../components/Headline";

import "../styles/FAQ.css";

const Panel = Collapse.Panel;

const messages = defineMessages({
  suggestion1: {
    id: "FAQ.collapse.suggestion.title.1",
    defaultMessage: "I would like to know the detailed conditions for registering a stickers.",
  },
  suggestion2: {
    id: "FAQ.collapse.suggestion.title.2",
    defaultMessage: "Are there any precautions when registering stickers?",
  },
  suggestion3: {
    id: "FAQ.collapse.suggestion.title.3",
    defaultMessage: "Is there any size or number of stickers suggested?",
  },
  suggestion4: {
    id: "FAQ.collapse.suggestion.title.4",
    defaultMessage: "How long will it take to review the sticker proposal?",
  },
  suggestion5: {
    id: "FAQ.collapse.suggestion.title.5",
    defaultMessage: "How long will it take to review the sticker proposal?",
  },
  registration1: {
    id: "FAQ.collapse.registration.title.1",
    defaultMessage: "Is it possible to re-upload existing stickers as plus pack?",
  },
  registration2: {
    id: "FAQ.collapse.registration.title.2",
    defaultMessage: "I uploaded basic pack, can I change it to a plus pack with more stickers?",
  },
  registration3: {
    id: "FAQ.collapse.registration.title.3",
    defaultMessage: "Can stickers of various languages be uploaded to plus packs like basic packs?",
  },
  registration4: {
    id: "FAQ.collapse.registration.title.4",
    defaultMessage: "Can pack information be entered in English only?",
  },
  registration5: {
    id: "FAQ.collapse.registration.title.5",
    defaultMessage: "Is it possible to delete packs?",
  },
  registration6: {
    id: "FAQ.collapse.registration.title.6",
    defaultMessage: "Is emotional tag selection mandatory?",
  },
  distribution1: {
    id: "FAQ.collapse.distribution.title.1",
    defaultMessage: "Can I sell it right away when I sign up for stickers distribution?",
  },
  distribution2: {
    id: "FAQ.collapse.distribution.title.2",
    defaultMessage: "I'd like to know why you didn't approve the sticker.",
  },
  distribution3: {
    id: "FAQ.collapse.distribution.title.3",
    defaultMessage: "Where is the sticker from which the distribution started?",
  },
  revenue1: {
    id: "FAQ.collapse.revenue.title.1",
    defaultMessage: "When the pack is distributed, does the creator receive a sales revenue?",
  },
  revenue2: {
    id: "FAQ.collapse.revenue.title.2",
    defaultMessage: "When will the revenue be remitted?",
  },
  revenue3: {
    id: "FAQ.collapse.revenue.title.3",
    defaultMessage: "How do I enter my remittance information?",
  },
  revenue4: {
    id: "FAQ.collapse.revenue.title.4",
    defaultMessage: "What currency is the revenue remittance in?",
  },
  revenue5: {
    id: "FAQ.collapse.revenue.title.5",
    defaultMessage: "Can I specify where to receive my revenue remittance?",
  },
  revenue6: {
    id: "FAQ.collapse.revenue.title.6",
    defaultMessage: "Is there a country that can not receive revenue remittance?",
  },
});

class FAQ extends Component {
  render() {
    const selectedKey = this.props.location.hash.replace("#", "");

    const { formatMessage } = this.props.intl;
    return (
      <Layout>
        <GuideNav selectedKey={"faq"}/>
        <Layout.Content style={{ margin: 20 }}>
          <Headline id="FAQ.headline" defaultMessage="FAQ" />
          <p className="faq-subtitle" id="suggestion">
            <FormattedMessage id="FAQ.subtitle.suggestion" defaultMessage="Suggestion" />
          </p>
          <Collapse className="faq-collapse">
            <Panel header={formatMessage(messages.suggestion1)} key="1">
              <FormattedHTMLMessage id="FAQ.collapse.suggestion.explain.1" defaultMessage="Stickerfarm can bring your stickers to anyone!<br/>Try it now!" />
            </Panel>
            <Panel header={formatMessage(messages.suggestion2)} key="2">
              <FormattedHTMLMessage
                id="FAQ.collapse.suggestion.explain.2"
                defaultMessage="Please check the guide and work with it.<br/>You can not ask for a sticker on someone else’s content, and you can only suggest it as content you produce or have a copyright.<br/><br/>※ To make a suggestion, please register your email account in a stickerfarm"
              />
            </Panel>
            <Panel header={formatMessage(messages.suggestion3)} key="3">
              <FormattedHTMLMessage
                id="FAQ.collapse.suggestion.explain.3"
                defaultMessage="A minimum of one sticker is allowed.<br/>Please check the size guidelines before production of the sticker."
              />
            </Panel>
            <Panel header={formatMessage(messages.suggestion4)} key="4">
              <FormattedMessage id="FAQ.collapse.suggestion.explain.4" defaultMessage="Basic pack can be created with one sticker. plus pack requires an upload of at least 24 stickers. In addition, plus pack have more opportunities to generate revenue than basic pack." />
            </Panel>
            <Panel header={formatMessage(messages.suggestion5)} key="5">
              <FormattedMessage id="FAQ.collapse.suggestion.explain.5" defaultMessage="The sticker review period is from 4 days to up to 2 weeks. Basic pack and plus pack go through the same screening process and period." />
            </Panel>
          </Collapse>
          <p className="faq-subtitle" id="registration">
            <FormattedMessage id="FAQ.subtitle.registration" defaultMessage="Registration" />
          </p>
          <Collapse className="faq-collapse">
            <Panel header={formatMessage(messages.registration1)} key="1">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.1"
                defaultMessage="Sticker packs already on Stickerfarm may not be reuploaded as plus pack."
              />
            </Panel>
            <Panel header={formatMessage(messages.registration2)} key="2">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.2"
                defaultMessage="No, the type of pack you set when uploading the sticker cannot be changed."
              />
            </Panel>
            <Panel header={formatMessage(messages.registration3)} key="3">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.3"
                defaultMessage="No, plus packs can only contain stickers of one language per pack."
              />
            </Panel>
            <Panel header={formatMessage(messages.registration4)} key="4">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.4"
                defaultMessage="The pack information input is recommended to use English. If you need to input pack information in other languages, you can add it by pressing the 'add language' button."
              />
            </Panel>
            <Panel header={formatMessage(messages.registration5)} key="5">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.5"
                defaultMessage="As sticker distribution and usage is immediately reflected in your earnings once submission is approved, pack and stickers within pack cannot be deleted after submission."
              />
            </Panel>
            <Panel header={formatMessage(messages.registration6)} key="6">
              <FormattedHTMLMessage
                id="FAQ.collapse.registration.explain.6"
                defaultMessage="Selection of emotion tags is mandatory when submitting stickers.<br/>The stickers will be recommended based on the tags that you’ve chosen.<br/><br/>Please select a tag that is suitable for your sticker,<br/>such as a related emotion, situation, behavior, or object.<br/><br/>If an unsuitable tag is selected,<br/>your sticker may be rejected during evaluation, thus delaying the approval process.<br/>Please refer to the tag guide to select an appropriate one!"
              />
            </Panel>
          </Collapse>
          <p className="faq-subtitle" id="distribution">
            <FormattedMessage id="FAQ.subtitle.distribution" defaultMessage="Distribution" />
          </p>
          <Collapse className="faq-collapse">
            <Panel header={formatMessage(messages.distribution1)} key="1">
              <FormattedHTMLMessage
                id="FAQ.collapse.distribution.explain.1"
                defaultMessage="Once a sticker has been added to the pack and emotion tags have been selected,<br/>you may click on “Submit for Approval” to begin the approval process for the pack.<br/>Approved pack will immediately begin distribution!"
              />
            </Panel>
            <Panel header={formatMessage(messages.distribution2)} key="2" style={{ lineHeight: "25px" }}>
              <p className="collapse-distribution-link">
                <FormattedHTMLMessage
                  id="FAQ.collapse.distribution.explain.2"
                  defaultMessage='For reasons of non-authorization, please refer to <a href="/guide/rejectedReasons" target="_blank">"Guide to Reject Reasons."</a>'
                />
              </p>
              <p className="collapse-distribution-caution">
                <FormattedHTMLMessage
                  id="FAQ.collapse.distribution.explain.2.caution"
                  defaultMessage="Even if any of the above guides doesn’t apply to your sticker, <br/>Stickerfarm can cease the sale of the sticker when it is judged inappropriate to be sold."
                />
              </p>
            </Panel>
            <Panel header={formatMessage(messages.distribution3)} key="3">
              <FormattedHTMLMessage
                id="FAQ.collapse.distribution.explain.3"
                defaultMessage="Stickers may be used on messaging services that have a contract with Stickerfarm to use content.<br/>The list of messaging services can be found on the “Channel” tab of the Guide menu."
              />
            </Panel>
          </Collapse>
          <p className="faq-subtitle" id="revenue">
            <FormattedMessage id="FAQ.subtitle.revenue" defaultMessage="Revenue" />
          </p>
          <Collapse className="faq-collapse">
            <Panel header={formatMessage(messages.revenue1)} key="1">
              <FormattedHTMLMessage id="FAQ.collapse.revenue.explain.1" defaultMessage="Revenue is updated monthly based on the usage rate of each sticker." />
            </Panel>
            <Panel header={formatMessage(messages.revenue2)} key="2">
              <FormattedHTMLMessage
                id="FAQ.collapse.revenue.explain.2"
                defaultMessage="You need a minimum of $100 in revenue in order to request a remittance.<br/>The creator's personal information entered in the remittance request is used only for remittance purposes and will be discarded after the remittance is complete.<br/>Revenue will be remitted to the registered payment account within 45 days of the request.<br/>(3.3% deduction)<br/><br/>If you submit a request before the 15th of the month, you will receive your revenue remittance by the end of that same month.<br/>Requests made after the 15th of every month will be processed by the end of the following month.<br/><br/>Request for remittance on 14 March - Remittance on 31 March<br/>Request for remittance on 16 March - Remittance on 30 April"
              />
            </Panel>
            <Panel header={formatMessage(messages.revenue3)} key="3">
              <FormattedHTMLMessage
                id="FAQ.collapse.revenue.explain.3"
                defaultMessage="You can register at “My Page”.<br/>The e-mail address must be the same as the e-mail address you signed up to stickerfarm."
              />
            </Panel>
            <Panel header={formatMessage(messages.revenue4)} key="4">
              <FormattedMessage id="FAQ.collapse.revenue.explain.4" defaultMessage="It’s the U.S dollar." />
            </Panel>
            <Panel header={formatMessage(messages.revenue5)} key="5">
              <p className="collapse-distribution-subtitle">
                <FormattedMessage id="FAQ.collapse.revenue.explain.5.subtitle.1" defaultMessage="If you live in Korea or Vietnam" />
              </p>
              <FormattedHTMLMessage id="FAQ.collapse.revenue.explain.5.subExplain.1" defaultMessage="- Financial institutions(banking and credit safe, etc.) are available in Korea and Vietnam." />
              <p className="collapse-distribution-subtitle">
                <FormattedHTMLMessage id="FAQ.collapse.revenue.explain.5.subtitle.2" defaultMessage="<br/>If you live outside of Korea and Vietnam" />
              </p>
              <FormattedHTMLMessage
                id="FAQ.collapse.revenue.explain.5.subExplain.2"
                defaultMessage="- You can use PayPal’s Premier or Business Account.<br/><br/>※ You can not use your personal account. Please check PayPal for the type of PayPal account.<br/>※ Please make sure your PayPal account can receive U.S dollars.<br/>※ You can not register with PayPal account if you are living in Korea."
              />
            </Panel>
            <Panel header={formatMessage(messages.revenue6)} key="6">
              <FormattedHTMLMessage
                id="FAQ.collapse.revenue.explain.6"
                defaultMessage="You can not get revenue remittance in countries or regions where PayPal is not available.<br/>Please check the PayPal remittance area."
              />
            </Panel>
          </Collapse>
        </Layout.Content>
      </Layout>
    );
  }
} //end FAQ class
 
FAQ = injectIntl(FAQ);

export default FAQ;
